// extracted by css-extract-rspack-plugin
export default {"receipt":"Receipt_receipt__c-mZy"};